import { ArrowDown, ArrowUpIcon } from '@/components/icons'
import { Site } from '@/types/siteLocation'
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC, useState } from 'react'

interface SitesAndLocationTableProps {
  row: Site
  onEditSiteItem: (id: string, name: string) => void
  onEditLocationItem: (id: string, name: string, siteId: string) => void
}

const SitesAndLocationTableRow: FC<SitesAndLocationTableProps> = ({
  row,
  onEditSiteItem,
  onEditLocationItem,
}) => {
  const handleEditSiteItem = (id: string, name: string) => {
    onEditSiteItem(id, name)
  }
  const handleEditLocationItem = (id: string, name: string, siteId: string) => {
    onEditLocationItem(id, name, siteId)
  }
  const [isExpanded, setIsExpanded] = useState(false)

  const toggle = () => {
    setIsExpanded(!isExpanded)
  }
  return (
    <>
      <>
        <TableRow key={row.id}>
          <TableCell component="th" scope="row">
            {row.level !== 2 ? (
              <IconButton aria-label="expand row" size="small" onClick={toggle}>
                {isExpanded ? <ArrowDown /> : <ArrowUpIcon />}
              </IconButton>
            ) : (
              <></>
            )}
          </TableCell>
          <TableCell>{row.siteLocationName}</TableCell>
          <TableCell>{row.numOfFloors}</TableCell>
          <TableCell>{row.numOfControllers}</TableCell>
          <TableCell>
            <Stack direction="row" spacing="10px">
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: '500',
                  lineHeight: '100%',
                  color: 'primary.main',
                  cursor: 'pointer',
                }}
                onClick={() => handleEditSiteItem(row.id, row.siteLocationName)}
              >
                EDIT
              </Typography>
            </Stack>
          </TableCell>
        </TableRow>
        {row.locations?.map((data) => (
          <TableRow key={data.id}>
            <TableCell style={{ padding: 0, width: '100vw' }} colSpan={6}>
              <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                <Table size="small" aria-label="purchases">
                  <TableHead sx={{ padding: 0, margin: 0, border: 0 }}>
                    <TableRow>
                      <TableCell
                        width="47px"
                        sx={{
                          margin: 0,
                          padding: 0,
                          border: '0 none',
                          height: 0,
                        }}
                      />
                      <TableCell
                        sx={{
                          width: '379.25px',
                          margin: 0,
                          padding: 0,
                          border: '0 none',
                          height: 0,
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          width: '339.25px',
                          margin: 0,
                          padding: 0,
                          border: '0 none',
                          height: 0,
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          width: '339.25px',
                          margin: 0,
                          padding: 0,
                          border: '0 none',
                          height: 0,
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          width: '339.25px',
                          margin: 0,
                          padding: 0,
                          border: '0 none',
                          height: 0,
                        }}
                      ></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell />
                      <TableCell sx={{ paddingLeft: '30px' }}>
                        {data.siteLocationName}
                      </TableCell>
                      <TableCell>{data.numOfFloors}</TableCell>
                      <TableCell>{data.numOfControllers}</TableCell>
                      <TableCell>
                        <Typography
                          sx={{
                            fontSize: '13px',
                            fontWeight: '500',
                            lineHeight: '100%',
                            color: 'primary.main',
                            cursor: 'pointer',
                          }}
                          onClick={() =>
                            handleEditLocationItem(
                              data.id,
                              data.siteLocationName,
                              row.id,
                            )
                          }
                        >
                          EDIT
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Collapse>
            </TableCell>
          </TableRow>
        ))}
      </>
      {/* <Stack sx={{ display: "flex", bottom: "0", justifyContent: "end", flexGrow: "1" }}>
        <TableFooter />
      </Stack> */}
    </>
  )
}

export default SitesAndLocationTableRow
